// extracted by mini-css-extract-plugin
export var select = "_qo-0";